import createTeamListProcess from "./team-list.js";
import {
    lookup,
    lookupOneCached
} from "../../utils/elements.js";

createTeamListProcess({
    teams: ["traveller"],
    listSelector: "#traveller-list__list",
    addButtonSelector: "#add-traveller",
    dialogSelector: "#traveller-list",
    onCharactersSelected(detail) {

        // Flag Travellers in the script as being included. For example, the
        // main 3 editions have Travellers that complement the script.
        // Homebrew scripts might have their own Travellers as well.

        const travellerIDs = detail.characters
            .filter((character) => character.getTeam() === "traveller")
            .map((character) => character.getId());

        lookup(
            ".js--character-list--item[data-token-id]",
            lookupOneCached("#traveller-list__list")
        ).forEach((item) => item.classList.toggle(
            "is-included",
            travellerIDs.includes(item.dataset.tokenId)
        ));

    }
});
